<template>
  <div class="cascader-box">
    <el-cascader
      ref="cascaderRef"
      v-model="schoolIds"
      :options="schoolList"
      placeholder="大区/区域/校区"
      :show-all-levels="false"
      :collapse-tags="true"
      :collapse-tags-tooltip="true"
      clearable
      filterable
      style="min-width: 250px !important"
      @change="select"
      v-bind="attrs"
      :props="propsConfig"
    />
  </div>
</template>

<script setup>
import {
  getManageAreaTree,
  getManageAreaTreeByCityLevel,
  getTeachAreaTree,
  getManageAreaAllTree,
  getNotShutdownTree,
  getRegionTreeAll,
  getHomePlanTree,
  getRegionOpenTree,
  getManageAreaTreePlus,
  getPlanTreeNotShotdown,
  getAreaCampusTree,
} from '@/api/kxmx/index';
import { listRegionAll } from '@/api/education/class';
import { nextTick, onMounted } from 'vue';
const cascaderRef = ref();
const props = defineProps({
  modelValue: {
    type: [String, Array],
  },
  type: {
    type: String, //默认为管理区域 ‘manage’,教学区域‘teach’
    default: 'manage',
  },
  returnType: {
    type: String, //返回数据类型 数组 Array 字符 逗号连接 String 多选有效
    default: 'Array',
  },
  checkAll: {
    type: Boolean,
    default: true,
  },
  checkOne: {
    type: Boolean,
    default: false,
  },
  additionalSelectorItem: {
    // 额外的校区选项，如增加“无”这种选项。如果传了，会放在选项最前面。
    type: Object, // 如：:additional-selector-item="{label: '无', id: '0'}"
    default: undefined,
  },
  // 筛选列表
  filterList: {
    type: Array,
    default: () => [],
  },

  defaultSingleSelect: {
    // 单选时生效，是否默认选中第一个校区
    type: Boolean,
    default: false,
  },
  presentText: {
    type: String,
    default: '',
  },
  cityLevel: {
    type: String, //默认为 一线 二线 三线 四线
    default: "",
  },
  params: {
    type: Object,
    default: () => {},
  },
});
const emits = defineEmits(['update:modelValue', 'checkedAll', 'change', 'update:presentText', 'checkedOne']);
const attrs = useAttrs();

const schoolIds = ref(null);
const schoolList = ref([]);
//报名校区配置
const propsConfig = reactive({
  value: 'id',
  label: 'label',
  multiple: true,
  emitPath: false,
});

if (props.type == 'areaCampus') {
  propsConfig.label = 'name';
}

watch(
  () => props.modelValue,
  (val) => {
    if (attrs.props) {
      Object.assign(propsConfig, attrs.props);
    }
    if (val) {
      if (propsConfig.multiple) {
        schoolIds.value = Array.isArray(val) ? val : val.split(',');
      } else {
        schoolIds.value = val;
      }
    } else {
      if (propsConfig.multiple) {
        schoolIds.value = [];
      } else {
        schoolIds.value = '';
      }
    }
    getLabels();
  },
  {
    deep: true,
    immediate: true,
  },
);
const LOCALKEY = ref('manage-schoolList');
const defVals = ref([]);

onMounted(() => {
  init();
});

//缓存数据
function setLocalSchools(data) {
  sessionStorage.setItem(LOCALKEY.value, JSON.stringify(data));
}
//缓存取值
function getLocalSchools() {
  let json = sessionStorage.getItem(LOCALKEY.value);
  if (json) {
    schoolList.value = JSON.parse(json);
    return false;
  } else {
    return true;
  }
}
function init() {
  // LOCALKEY.value = `${props.type}-schoolList`
  // let isSerach = getLocalSchools();
  // if (isSerach) {
  //   getRegionList();
  // }else{
  //   isCheckAll()
  // }
  getRegionList();
}
// const unwatchCityLevel = watch(
//   () => props.cityLevel,
//   (val) => {
//     getRegionList();
//   },
// {
//   immediate: true,
// });
// onUnmounted(() => {
//   unwatchCityLevel();
// });
function getLabels() {
  nextTick(() => {
    const checkedNodes = cascaderRef.value.getCheckedNodes(true);
    const selectedLabels = checkedNodes.map((node) => node.label);
    const presentText = (selectedLabels || []).join(',');
    emits('update:presentText', presentText);
  });
}
/** 查询管理/教学区域数据 */
async function getRegionList() {
  let res = null;
  if (props.type == 'manage') {
    // 有权限管理区域
    res = await getManageAreaTreeByCityLevel({ cityLevel: props.cityLevel });
  } else if (props.type == "manageAll") {
    //无权限管理区域校区
    res = await getManageAreaAllTree();
  } else if (props.type == 'manageRegister') {
    //启用的管理区域校区
    res = await listRegionAll();
  } else if (props.type == 'teach') {
    res = await getTeachAreaTree();
    if (res.data?.length > 0) {
      res.data = [
        {
          id: '001',
          label: '集团校区',
          children: [...res.data],
        },
      ];
    }
  } else if (props.type == 'notShutdown') {
    res = await getNotShutdownTree();
  } else if (props.type == 'hwgAll') {
    res = await getRegionTreeAll();
  } else if (props.type == 'planSchool') {
    // 计划内校区，用于高管首页
    res = await getHomePlanTree();
  } else if (props.type == 'regionOpenTree') {
    // 教材专用
    res = await getRegionOpenTree();
  } else if (props.type == 'planSchoolNotShutdown') {
    // 计划内校区，未关闭的校区
    res = await getPlanTreeNotShotdown();
  } else if (props.type == 'managePlus') {
    // 有权限管理区域加待分配校区
    res = await getManageAreaTreePlus();
  } else if (props.type == 'areaCampus') {
    // 负责人校区
    res = await getAreaCampusTree({ insidePlan: 0, level: 3, ...props.params });
  } 
  if (props.additionalSelectorItem) {
    res.data.unshift(props.additionalSelectorItem);
  }
  schoolList.value = props.filterList.length === 0 ? res.data : treeFilter(res.data, ({ id }) => props.filterList.includes(id));
  isCheckAll();
  nextTick(() => {
    const presentText = cascaderRef.value?.presentText;
    emits('update:presentText', presentText);
  });
}

function treeFilter(tree, func) {
  return tree
    .map((node) => ({ ...node }))
    .filter((node) => {
      node.children = node.children && treeFilter(node.children, func);
      return func(node) || (node.children && node.children.length);
    });
}

function isCheckAll(options = { force: false }) {
  if (props.checkOne) {
    if (schoolList.value?.length > 0) {
      getAllValues(toRaw(schoolList.value));
      schoolIds.value = [defVals.value[0]];
      select(toRaw(schoolIds.value));
      emits('checkedOne');
    } else {
      emits('checkedOne');
    }
    return;
  }
  if (props.checkAll == true && propsConfig.multiple && (!props.modelValue?.length || options.force)) {
    if (schoolList.value?.length > 0) {
      getAllValues(toRaw(schoolList.value));
      schoolIds.value = [...defVals.value];
      select(toRaw(schoolIds.value));
      emits('checkedAll'); // 全部选中完成，抛出事件，便于调用方初始化
    } else {
      emits('checkedAll'); // 全部选中完成，抛出事件，便于调用方初始化
    }
  }
  if (props.defaultSingleSelect && !propsConfig.multiple && schoolList.value?.length) {
    // 单选时，默认选中第一个
    const findFirst = (list) => {
      if (list[0].children?.length) {
        return findFirst(list[0].children);
      } else {
        return list[0].id;
      }
    };
    const firstId = findFirst(schoolList.value);
    if (firstId) {
      emits('update:modelValue', firstId);
      emits('checkedAll');
    } else {
      emits('checkedAll');
    }
  }
}

defineExpose({
  cascaderRef,
  getRegionList,
  schoolList,
  getSchoolName,
  doCheckAll: isCheckAll, // 全选中函数，便于重置时调用
  getSingleAreaNode,
});

function getAllValues(val) {
  val.forEach((element) => {
    if (element.hasOwnProperty('children') && element.children.length > 0) {
      getAllValues(element.children);
    } else {
      defVals.value.push(element.id);
    }
  });
}
/**选择校区时，获取校区id */
function select(vals) {
  emits('change', vals);
  if (props.returnType == 'Array') {
    emits('update:modelValue', vals);
  } else if (props.returnType == 'String') {
    if (propsConfig.multiple) {
      if (vals.length > 0) {
        emits('update:modelValue', vals.join(','));
      } else {
        emits('update:modelValue', '');
      }
    } else {
      emits('update:modelValue', vals);
    }
  }
  const presentText = cascaderRef.value.presentText;
  emits('update:presentText', presentText);
}

// 获取选中的校区中文名
function getSchoolName() {
  const checkedNodes = cascaderRef.value.getCheckedNodes(true);
  const selectedLabels = checkedNodes.map((node) => node.label);
  return (selectedLabels || []).join(',');
}

// 单选时，获取选中的校区，第二级即区域名称，如光谷校区 --- 返回武汉一区
function getSingleAreaNode() {
  const checkedNodes = cascaderRef.value.getCheckedNodes(false)[0];
  return checkedNodes.pathLabels[1]
}
</script>

<style lang="scss" scoped>
.cascader-box {
  width: 280px;
  :deep(.el-cascader) {
    width: inherit;

    .el-input {
      width: var(--el-input-width) !important;
    }

    .el-cascader__tags {
      flex-wrap: nowrap;

      .el-cascader__search-input {
        min-width: 0px;
      }
    }
  }
}
</style>
